import React from 'react';
import {
  Box,
  Container,
  Card,
  CardContent,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 100,
  },
}));

import TextField from '@material-ui/core/TextField';

import Question from '../question/Question';
import { WallpaperRounded } from '@material-ui/icons';

const RadioBig = ({
  icon,
  label,
  width,
  height,
  index,
  name,
  selectedValue,
  handleChange,
  hovercolor,
  headline,
  text,
  url,
  text2,
  text3,
  border,
}) => {
  const useStyles = makeStyles({
    card: {
      width: 278 || 180,
      height: 241 || 135,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',

      marginLeft: '10px',
      marginRight: '10px',
      marginTop: '2px',
      marginBottom: '20px',
      border: border ? 'solid 3px #63b65c' : '',

      '&:hover': {
        border:
          hovercolor == undefined
            ? '5px solid #1D85FE'
            : '5px solid ' + hovercolor,
        boxShadow: '0 9px 12px 0 rgba(0,0,0,.2)',
        transform: 'translateY(-2px)',
        padding: '0px',
      },
    },
    selectedCard: {
      border: '5px solid #1D85FE',
      boxShadow: '0 9px 12px 0 rgba(0,0,0,.2)',
      transform: 'translateY(-1px)',
      padding: '0px',
    },
  });
  const classes = useStyles();
  return (
    <>
      <input
        id={`radioQuestion-${index}`}
        type="radio"
        name={name}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
      <label htmlFor={`radioQuestion-${index}`}>
        <Card
          className={clsx(
            classes.card,
            selectedValue != undefined && index === selectedValue
              ? classes.selectedCard
              : ''
          )}
          variant="outlined"
        >
          <div className="flex flex-col justify-between  place-items-center h-full w-full">
            <div className="w-full">
              {border && (
                <div
                  className="h-30px flex place-items-center justify-center mb-15px wrapdreieck"
                  style={{ backgroundColor: '#63b65c' }}
                >
                  <div className="dreieck"></div>
                  <img width="20px" src={url + 'wappensymbol.jpg'} />
                  <div className="ml-5px text-xs text-white-1">
                    Empfohlen für den Immobilienverkauf
                  </div>
                </div>
              )}
              {!border && (
                <div className="h-30px flex place-items-center justify-center mb-15px"></div>
              )}
              <div className="text-center text-lg">
                <strong>{headline}</strong>
              </div>
              <div className="text-center text-sm">{text}</div>
            </div>
            <div>
              <img style={{ height: '75px', width: 'auto' }} src={icon} />
            </div>
            <div>
              <div className="flex">
                <img width="22px" src={url + 'haken.jpg'} />
                <div className="ml-10px text-base">{text2}</div>
              </div>
              <div className="flex mb-20px">
                <img width="22px" src={url + 'haken.jpg'} />
                <div className="ml-10px text-base">{text3}</div>
              </div>
            </div>
          </div>
        </Card>
      </label>
    </>
  );
};

const ArtderBeratung = ({
  daten,
  cardcontent,
  handleNext,
  url,
  hovercolor,
}) => {
  let cardID =
    daten['chain'].length > 0
      ? daten['chain'][daten['chain'].length - 1].toString()
      : daten['chain'][0].toString();
  let step = daten['chain'].length;

  let selectedValue = undefined;
  try {
    selectedValue = daten['info'][cardID]['selection'];
  } catch (error) {
    //no catch
  }
  const handleChange = index => {
    cardID in daten['info'] ? 0 : (daten['info'][cardID] = {}); //Create Dict in Info if not exists
    daten['info'][cardID]['selection'] = index;
    handleNext(daten);
  };

  const classes = useStyles();

  let renderObjekt = (
    <div
      className="flex flex-col flex-wrap items-center justify-center smx:flex-row "
      id="ArtderBeratung"
    >
      <RadioBig
        key={0}
        index={0}
        name={'radio' + 0}
        selectedValue={selectedValue}
        label={0}
        handleChange={e => handleChange(0)}
        icon={url + 'onlineberatungnew.jpg'}
        width={230}
        height={231}
        hovercolor={hovercolor}
        headline={'Online - Bewertung'}
        text={'durch einen datenbasierten Algorithmus'}
        url={url}
        text2={'Grobe Wertspanne'}
        text3={'Ergebnis kommt per E-Mail'}
      />
      <RadioBig
        key={1}
        index={1}
        name={'radio' + 1}
        selectedValue={selectedValue}
        label={1}
        handleChange={e => handleChange(1)}
        icon={url + 'persoenlichebewertung.jpg'}
        width={230}
        height={231}
        hovercolor={hovercolor}
        headline={'Persönliche Bewertung'}
        text={'durch erfahrene Experten in Ihrer Region'}
        url={url}
        text2={'Präzise Bewertung'}
        text3={'Lokaler Immobilienexperte'}
        border={true}
      />
    </div>
  );

  return (
    <div className="h-full flex flex-col justify-between ">
      <div className="text-center mt-40px">
        <Question questionNo={step} questionText={cardcontent['headline']} />
      </div>

      <div className="mx-auto">{renderObjekt}</div>

      <div className="h-20px"></div>
    </div>
  );
};

export default ArtderBeratung;
